import { CornerSquareTypes } from "../types";

export default {
  dot: "dot",
  square: "square",
  extraRounded: "extra-rounded"
} as CornerSquareTypes;
